import { Backdrop, Typography } from '@mui/material';
import React from 'react';
import { createPortal } from 'react-dom';
import loadingGif from '../../../assets/images/skillinsightloader.gif';

const style = {
  position: 'fixed',
  top: '56%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 999999
};

const loaderStyle = {
  height: 130,
  marginBottom: 15,
  marginLeft: 17
};

export default function CustomSpinner({ open, text }) {
  return createPortal(
    <>
      <Backdrop sx={{ color: '#fff', opacity: '10%', zIndex: 999999 }} open={open}>
        <img src={loadingGif} alt="loading.." style={loaderStyle} />
      </Backdrop>
      {open && text && (
        <Typography className="text-white" style={style}>
          {text}
        </Typography>
      )}
    </>,
    document.body
  );
}
